'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { Index, Configure } from 'react-instantsearch';
import DesktopProductListingSidebarContainer from 'components/consumer/ProductListingPage/components/desktop/DesktopProductListingSidebarContainer';
import { ALGOLIA_INDEX_NAME, ALGOLIA_PRODUCT_INDEXES } from 'commons/constants';
import QuickShipFilter from 'components/essentials/ConsumerFilters/components/QuickShipFilter';
import removeQuickshipFacet from '../../../advanced-search/helpers/removeQuickshipFacet';
import useAdvancedSearchContext from '../../hooks/useAdvancedSearchContext';
import SectionButtons from './components/SectionButtons';
import WidthRangeFilter from '../WidthRangeFilter';
import ClearAllFiltersButtonComponent from '../ClearAllFiltersButton';
import ProductTypeRefinementList from './components/ProductTypeRefinementList';
const AdvancedSearchSidebar = () => {
  const $ = _c(45);
  const {
    currentSearchSection,
    updateSearchSection,
    isReadyToShipActive,
    handleToggleReadyToShip
  } = useAdvancedSearchContext();
  let t0;
  if ($[0] !== isReadyToShipActive) {
    t0 = isReadyToShipActive ? ["is_in_stock:true"] : [];
    $[0] = isReadyToShipActive;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const facetFilters = t0;
  let t1;
  if ($[2] !== facetFilters) {
    t1 = removeQuickshipFacet(facetFilters);
    $[2] = facetFilters;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const sanitizedFacetFilters = t1;
  let t2;
  if ($[4] !== currentSearchSection) {
    t2 = ALGOLIA_PRODUCT_INDEXES.includes(currentSearchSection);
    $[4] = currentSearchSection;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const showProductFilters = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h2 className="text-base font-bold text-gray px-0 py-4">Refine by:</h2>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== updateSearchSection) {
    t4 = () => {
      updateSearchSection?.(ALGOLIA_INDEX_NAME.PRODUCTS);
    };
    $[7] = updateSearchSection;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = currentSearchSection === ALGOLIA_INDEX_NAME.PRODUCTS;
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <SectionButtons title="Products" onClick={t4} active={t5} />;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = ["*"];
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== sanitizedFacetFilters) {
    t8 = <Configure facets={t7} numericFilters="" facetFilters={sanitizedFacetFilters} />;
    $[13] = sanitizedFacetFilters;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== updateSearchSection) {
    t9 = () => {
      updateSearchSection?.(ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS);
    };
    $[15] = updateSearchSection;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = currentSearchSection === ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS;
  let t11;
  if ($[17] !== t10 || $[18] !== t9) {
    t11 = <SectionButtons title="Customer Photos" onClick={t9} active={t10} />;
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t8) {
    t12 = <Index indexName={ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS}>{t8}{t11}</Index>;
    $[20] = t11;
    $[21] = t8;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Configure facets={["*"]} numericFilters="" facetFilters="" />;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== updateSearchSection) {
    t14 = () => {
      updateSearchSection?.(ALGOLIA_INDEX_NAME.REVIEWS);
    };
    $[24] = updateSearchSection;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  const t15 = currentSearchSection === ALGOLIA_INDEX_NAME.REVIEWS;
  let t16;
  if ($[26] !== t14 || $[27] !== t15) {
    t16 = <Index indexName={ALGOLIA_INDEX_NAME.REVIEWS}>{t13}<SectionButtons title="Reviews" onClick={t14} active={t15} /></Index>;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Configure numericFilters={["is_active=1", "show_in_search=1", "fk_store_id=1"]} />;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== updateSearchSection) {
    t18 = () => {
      updateSearchSection?.(ALGOLIA_INDEX_NAME.STATIC_PAGES);
    };
    $[30] = updateSearchSection;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  const t19 = currentSearchSection === ALGOLIA_INDEX_NAME.STATIC_PAGES;
  let t20;
  if ($[32] !== t18 || $[33] !== t19) {
    t20 = <Index indexName={ALGOLIA_INDEX_NAME.STATIC_PAGES}>{t17}<SectionButtons title="Pages" onClick={t18} active={t19} /></Index>;
    $[32] = t18;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== handleToggleReadyToShip || $[36] !== isReadyToShipActive || $[37] !== showProductFilters) {
    t21 = showProductFilters && <><div className="mt-4"><ClearAllFiltersButtonComponent /></div><div className="mt-4"><QuickShipFilter isChecked={isReadyToShipActive} onChange={handleToggleReadyToShip} minHeight={false} withLocation={true} /></div><div className="mt-4"><WidthRangeFilter showTitle={true} /></div><div><h3 className="text-base font-bold mb-2 mt-4">Product Type</h3><ProductTypeRefinementList /></div></>;
    $[35] = handleToggleReadyToShip;
    $[36] = isReadyToShipActive;
    $[37] = showProductFilters;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== t12 || $[40] !== t16 || $[41] !== t20 || $[42] !== t21 || $[43] !== t6) {
    t22 = <DesktopProductListingSidebarContainer isOpen={true}>{t3}{t6}{t12}{t16}{t20}{t21}</DesktopProductListingSidebarContainer>;
    $[39] = t12;
    $[40] = t16;
    $[41] = t20;
    $[42] = t21;
    $[43] = t6;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  return t22;
};
export default AdvancedSearchSidebar;